import React from 'react';

function RepDisplayName({ rep }) {
  if (rep.includes('Casey Johnson')) {
    return 'Director of Sales';
  }
  if (rep.includes('contract-accounts')) {
    return 'Contract Accounts';
  }
  if (rep.includes('all-reps')) {
    return 'All Reps';
  }
  return rep;
}

export default React.memo(RepDisplayName);
